import { render, staticRenderFns } from "./AppointmentsTrialsOverNoNewAppointmentsStatistics.vue?vue&type=template&id=3e438c4b"
import script from "./AppointmentsTrialsOverNoNewAppointmentsStatistics.vue?vue&type=script&lang=ts"
export * from "./AppointmentsTrialsOverNoNewAppointmentsStatistics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports